<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.yearData.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.yearData.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.yearData.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.yearData.totalWeight')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="statrtYear" type="year" :placeholder="$t('pages.yearData.startYear')" class="handle-select mr10" :picker-options="pickerOptions0" style="width:20%;"></el-date-picker>
                <el-date-picker v-model="endYear" type="year" :placeholder="$t('pages.yearData.endYear')" class="handle-select mr10" :picker-options="pickerOptions0" style="width:20%;"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.yearData.scale')" class="handle-select mr10" style="width:20%;">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.yearData.search')}}</el-button>
            </div>
        </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" id="mytable" ref="mytable" :height="tableHeight">
            <el-table-column type="index" width="80" :label="$t('pages.yearData.index')"></el-table-column>
            <el-table-column sortable prop="date" :label="$t('pages.yearData.year')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }}
                </template>
            </el-table-column>
            <el-table-column prop="balanceId" :label="$t('pages.yearData.scaleId')"></el-table-column>
            <el-table-column :prop="isDisplayCompanyName ? 'fullBalanceName' : 'balanceName'" :label="$t('pages.yearData.scaleName')"></el-table-column>
            <el-table-column :label="$t('pages.yearData.yearWeight')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.weight }}</el-button>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.yearData.yearCnb')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.yearCNB }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() == Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            tableHeight: window.innerHeight * 0.70,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            pageCount: 1,
            statrtYear: '',
            endYear: '',
            isDisplayCompanyName: false,
            query: {
                StatrtYear: '',
                EndYear: '',
                userName: '',
                balanceId: 0,
                createUserId: 0,
                PageIndex: 1,
                PageSize: 25
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        }
    },
    created() {
        this.statrtYear = new Date();
        this.endYear = new Date();
        this.getBalance();
    },
    methods: {
        getData() {
            this.query.StatrtYear = new Date(this.statrtYear).getFullYear();
            this.query.EndYear = new Date(this.endYear).getFullYear();
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.query.createUserId = userInfo.id;
            this.query.userName = userInfo.realName;
            this.$zybhttp
                .post('ProdInquiry/YearData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                        this.pageCount = res.data.data.total || 0;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.yearData.yes') ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.yearData.fetchError')));
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.yearData.yes') ? true : false;
                        this.balanceArr = [{
                            id: 0,
                            name: '全部',
                            fullName: '全部',
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        },
        printlist() {
            // var headWidth = this.$refs.mytable.bodyWidth;
            // // ".el-table__header"
            // let html = document.querySelector('#mytable').innerHTML;
            // // 新建一个 DOM
            // const div = document.createElement('div');
            // const printDOMID = 'printDOMElement';
            // div.id = printDOMID;
            // div.innerHTML = html;

            // // 提取第一个表格的内容 即表头
            // const ths = div.querySelectorAll('.el-table__header-wrapper th');
            // const ThsTextArry = [];
            // for (let i = 0, len = ths.length; i < len; i++) {
            //     if (ths[i].innerText !== '')
            //     ThsTextArry.push(ths[i].innerText);
            // }

            // // 删除多余的表头
            // div.querySelector('.hidden-columns').remove();
            // // 第一个表格的内容提取出来后已经没用了 删掉
            // div.querySelector('.el-table__header-wrapper').remove();

            // // 将第一个表格的内容插入到第二个表格
            // let newHTML = '<tr>';
            // for (let i = 0, len = ThsTextArry.length; i < len; i++) {
            //     newHTML += '<td style="text-align: left; font-weight: bold">' + ThsTextArry[i] + '</td>';
            // }

            // newHTML += '</tr>';
            // div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML);
            // // 将新的 DIV 添加到页面 打印后再删掉
            // document.querySelector('body').appendChild(div);
            // console.log(document.querySelector('body').innerHTML);
            // print({
            //     printable: printDOMID,
            //     type: 'html',
            //     scanStyles: false,
            //     style: 'tr td { border-collapse: collapse;padding: 15px;border:1px #000 solid;} ' // 表格样式
            // });

            // div.remove();

            // print({
            //     printable: 'mytable',
            //     type: 'html',
            //     header: '年产量查询',
            //     headerStyle: 'text-align:center;color:#f00;width:100%;border:1px #000 solid;',
            //     targetStyles: ['border', 'padding: 15px'],
            //     scanStyles: false,
            //     style: 'table tr td,th { border-collapse: collapse;padding: 15px 0px;border:1px #000 solid;} ' // 表格样式
            // });

            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.yearData.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.yearData.index'),
                        columnSize: `5%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.yearData.year'),
                        columnSize: `20%`
                    },
                    {
                        field: 'balanceId',
                        displayName: this.$t('pages.yearData.scaleId'),
                        columnSize: `10%`
                    },
                    {
                        field: this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName',
                        displayName: this.$t('pages.yearData.scaleName')
                    },
                    {
                        field: 'weight',
                        displayName: this.$t('pages.yearData.yearWeight'),
                        columnSize: `10%`
                    },
                    {
                        field: 'yearCNB',
                        displayName: this.$t('pages.yearData.yearCnb'),
                        columnSize: `15%`
                    }
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:center;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.yearData.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
    margin-right: -195px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
